import {
  mutationNames
} from '@/store/storeKeysettings'

const state = {
  Stream: null,
  AudioPlayers: [],
  VideoPlayerArray: [],
  ActivePlayerInfo: null,
  AudioPlayersInfo: []
}

const mutations = {
  [mutationNames.ADD_STREAM](state, stream) {
    state.Stream = stream
  },
  [mutationNames.ADD_STREAMLIKE](state, payload) {
    if (state.Stream.Id === payload.Reference_Id) {
      state.Stream.IsLiked = payload.Liked
      return state.Stream
    }
  },
  [mutationNames.UPDATE_STREAM](state, stream) {
    state.Stream = stream
  },
  [mutationNames.UPDATE_AUDIO_PLAYER](state, payload) {
    state.AudioPlayers = payload
  },
  [mutationNames.UPDATE_AUDIO_PLAYER_INFO](state, payload) {
    state.AudioPlayers.map(playerInfo => {
      if(playerInfo.id === payload.id) {
        playerInfo.timeProgress = payload.timeProgress
        playerInfo.endTime = payload.endTime
        playerInfo.timeProgressPercent = payload.timeProgressPercent
      }
    })
  },
  [mutationNames.UPDATE_VIDEO_PLAYER](state, payload) {
    state.VideoPlayerArray = payload
  },
  updateActivePlayerInfo (state, payload) {
    state.ActivePlayerInfo = payload
  },
  updateAudioPlayersInfo (state, payload) {
    state.AudioPlayersInfo = payload
  }
}

const actions = {
  initStreamData: ({
    commit
  }) => {
    commit(mutationNames.ADD_STREAM)
  },
  updateVideoPlayerArray: ({
    commit
  }, payload) => {
    commit('UPDATE_VIDEO_PLAYER', payload)
  },
  updateAudioPlayers: ({
    commit
  }, payload) => {
    commit('UPDATE_AUDIO_PLAYER', payload)
  },
  updateAudioPlayerTimes: ({
    commit
  }, payload) => {
    commit('UPDATE_AUDIO_PLAYER_INFO', payload)
  },
  updateActivePlayerInfo: ({
    commit
  }, payload) => {
    commit('updateActivePlayerInfo', payload)
  },
  updateAudioPlayersInfo: ({
    commit
  }, payload) => {
    commit('updateAudioPlayersInfo', payload)
  }
}

const getters = {
  Stream: state => {
    return state.Stream
  },
  AudioPlayers: state => {
    return state.AudioPlayers
  },
  VideoPlayerArray: state => {
    return state.VideoPlayerArray
  },
  ActivePlayerInfo: state => {
    return state.ActivePlayerInfo
  },
  AudioPlayersInfo: state => {
    return state.AudioPlayersInfo
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/radioStream.js